export const MARKER_SECTOR_DEFAULT_SIZE = {
  width: 27,
  height: 31,
};
export const MARKER_SECTOR_SCALE = {
  DEFAULT: 1,
};
